"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.esRenovable = void 0;
exports.lineaVigenteWhere = lineaVigenteWhere;
exports.lineaCentroVigenteWhere = lineaCentroVigenteWhere;
exports.resolveEstadoLinea = resolveEstadoLinea;
exports.esAdscripcionVigente = esAdscripcionVigente;
// ───────────── Línea / adscripción vigencia — shared source of truth (R55) ─────
//
// ONE business rule — "a line/subscription is alive if it was already created
// (or subscribed) and has not yet died" — expressed in TWO forms, side by side,
// on purpose:
//
//   1. A Prisma *where-fragment*  (`lineaVigenteWhere` / `lineaCentroVigenteWhere`)
//      — travels to SQL, used to FILTER rows in a query.
//   2. A pure *row predicate*     (`resolveEstadoLinea` / `esAdscripcionVigente`)
//      — evaluates a single already-fetched row in memory, used by the admin
//        dashboard (`/admin/lineas`) to compute a per-row state/badge.
//
// A where-fragment cannot delegate to a predicate (Prisma needs a query object,
// not a function) and a predicate cannot delegate to a where-fragment (it has no
// database to query against). They CANNOT share one implementation — so they are
// co-located here instead: whoever edits one of these four functions sees the
// other three right next to it and keeps them in sync by hand.
//
// `lineaVigenteWhere`/`lineaCentroVigenteWhere` were moved verbatim (same
// semantics, same boundary) from the `private` methods of
// `apps/api/src/common/lineas/linea-disponibilidad.service.ts` — the service
// that gates the CV modal and the registration wizard. Do NOT change their
// semantics here without re-running `linea-disponibilidad.service.spec.ts`.
//
// Boundary is INCLUSIVE on both ends: a line/subscription expiring exactly
// `today` is still vigente (`gte: today`, not `gt`).
/** A research line (`linea_investigacion`) is alive from its creation date
 * until (and including) its derogation date, if any. */
function lineaVigenteWhere(today) {
    return {
        fechaCreacion: { lte: today },
        OR: [{ fechaDerogacion: null }, { fechaDerogacion: { gte: today } }],
    };
}
/** A center subscription (`lineas_centro`) is alive from its `fechaAdscripcion`
 * until (and including) its `fechaExpiracion`, if any. */
function lineaCentroVigenteWhere(today) {
    return {
        fechaAdscripcion: { lte: today },
        OR: [{ fechaExpiracion: null }, { fechaExpiracion: { gte: today } }],
    };
}
function resolveEstadoLinea(linea, today) {
    if (linea.fechaCreacion > today)
        return 'programada';
    if (linea.fechaDerogacion !== null && linea.fechaDerogacion < today)
        return 'derogada';
    return 'vigente';
}
/** Only a currently-vigente line is eligible for `renovar`. */
const esRenovable = (estado) => estado === 'vigente';
exports.esRenovable = esRenovable;
/**
 * Per-row validity predicate for a center subscription — mirrors
 * `lineaCentroVigenteWhere`'s real logic exactly (`fechaAdscripcion <= today`
 * AND `fechaExpiracion` null-or->=today). Needed by the admin dashboard's
 * subscriptions panel and by the derogar/renovar cascade (which must act only
 * on currently-valid subscriptions).
 */
function esAdscripcionVigente(adscripcion, today) {
    if (adscripcion.fechaAdscripcion > today)
        return false;
    if (adscripcion.fechaExpiracion !== null && adscripcion.fechaExpiracion < today)
        return false;
    return true;
}
